<template>
  <div role="tablist">
    <p>{{ $t("props.cornerMinSize") }}</p>
      <question id="1" :title="$t('questions.measureCorner')">
        <input-measure
          v-model="value.size"
          :show-image="false"
        />
      </question>
    <question id="2" :title="$t('questions.boxAmount')" class="mt-2">
      <input-amount v-model="value.amount" />
    </question>
    <question id="3" :title="$t('questions.additionalNotes')" class="mt-2">
      <input-additional-notes v-model="value.additionalNotes" />
    </question>
  </div>
</template>
<script>
import { ProductMixin } from './Product.mixin'

export default {
  name: 'Corner',
  mixins: [ProductMixin]
}
</script>
